var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){return _vm.manage()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"deep-purple lighten-2"}},[_vm._v("open_in_new")])],1),_c('span',[_vm._v("Manage")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }